export const metaLeadFormsStrings = {
  title: "Formularios Meta Lead Ads",
  subtitle:
    "Registra formularios de Facebook por id y nombre, y elige si el lead se asigna de inmediato o entra a calificación por WhatsApp.",
  emptyTitle: "Aún no hay formularios registrados",
  emptyBody:
    "Agrega el form id de Meta y elige el flujo. Los formularios con prefijos históricos (datos_clientes, etc.) siguen funcionando aunque no estén aquí.",
  addForm: "Registrar formulario",
  editForm: "Editar formulario",
  save: "Guardar",
  cancel: "Cancelar",
  delete: "Eliminar",
  deleteConfirm: "¿Eliminar este formulario del registro?",
  formName: "Nombre del formulario",
  formId: "Form ID (Meta)",
  formIdHint: "Id numérico del formulario en Meta Lead Ads",
  notes: "Notas (opcional)",
  enabled: "Activo",
  flowTitle: "¿Cómo deben entrar estos leads?",
  flowImmediateTitle: "Asignación inmediata",
  flowImmediateBody: "El lead se guarda y se asigna a un ventor de inmediato.",
  flowQualifyTitle: "Calificación IA (WhatsApp)",
  flowQualifyBody:
    "Se guarda el lead sin asignar. Esperamos a que escriba por WhatsApp; si no lo hace, enviamos el template tras el delay.",
  settingsTitle: "Delay de WhatsApp",
  settingsBody: "Minutos de espera antes del primer mensaje de calificación si el lead no escribe.",
  settingsMinutes: "Minutos",
  settingsSave: "Guardar delay",
  loadError: "No se pudo cargar el registro de formularios",
  saveError: "No se pudo guardar el formulario",
  deleteError: "No se pudo eliminar el formulario",
  settingsError: "No se pudo guardar el delay",
  saved: "Formulario guardado",
  deleted: "Formulario eliminado",
  settingsSaved: "Delay actualizado",
  chipImmediate: "Asignación",
  chipQualify: "Calificación",
  chipDisabled: "Inactivo",
} as const
